export default class ErrorHandler {
    static errorInstance:ErrorHandler
    errorCode:string;
    permDenied :boolean;
    constructor() {
        this.errorCode="ER10000"
        this.permDenied = false
    }
    static getErrorInstance(){
        if (!ErrorHandler.errorInstance) {
            ErrorHandler.errorInstance = new ErrorHandler();
        }
        return this.errorInstance;
    }
    async updateErrorCode(code:string){
        if((code?.includes("ER1")|| code?.includes("ER2"))&& code?.length===7){
            this.errorCode=code
        }
        else if(code === "PERMISSION_DENIED")
            {
                this.errorCode = "ER30000"
                this.permDenied = true
            }
    }
      
}